import * as VideoPlayerActions from '../actions/videoActions'
import { Map } from 'immutable'
import * as VideoPlayStates from '../constants/videoPlayStates'

const INITIAL_STATE = Map({
    videoPlayer: null,
    player: null,
    videoPlayState: VideoPlayStates.STOPPED,
    isVideoUIVisible: true,
    isVideoPlaying: false,
    videoQualityOptions: [],
    videoQuality: null,
    videoVolume: 100,
    videoStartTime: null,
    isVideoVolumeMuted: false,
    draggingHint: Map({
        isVisible: true,
        delay: 2500,
    }),
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case VideoPlayerActions.REGISTER_VIDEO_PLAYER:
            const player = state.get('videoPlayer')

            player && player.dispose()

            return state.set('videoPlayer', {
                enableAccelerometerControls: enabled => action.player.enableAccelerometerControls(enabled),

                dispose: _ => (action.player = null),
            })
        case VideoPlayerActions.DESTROY_VIDEO_PLAYER:
            return state.set('videoPlayer', null)
        case VideoPlayerActions.SET_VIDEO_PLAYER:
            return state.set('player', action.player)
        case VideoPlayerActions.SHOW_VIDEO_UI:
            return state.set('isVideoUIVisible', true)
        case VideoPlayerActions.HIDE_VIDEO_UI:
            return state.set('isVideoUIVisible', false)
        case VideoPlayerActions.PLAY_VIDEO:
            return state.set('isVideoPlaying', true)
        case VideoPlayerActions.PAUSE_VIDEO:
            return state.set('isVideoPlaying', false)

        case VideoPlayerActions.SET_QUALITY_LIST:
            return state.set('videoQualityOptions', action.videoQualityOptions)
        case VideoPlayerActions.SET_CURRENT_QUALITY:
            return state.set('videoQuality', action.videoQuality)

        case VideoPlayerActions.SET_VIDEO_VOLUME:
            // let newState = state

            // // if we're changing volume,
            // // adjust muted state if that is necessary
            // if (action.volume == 0 && !state.get('isVideoVolumeMuted')) {
            //     newState = newState.set('isVideoVolumeMuted', true)
            // } else if (action.volume > 0 && state.get('isVideoVolumeMuted')) {
            //     newState = newState.set('isVideoVolumeMuted', false)
            // }

            // // and set volume itself
            // newState = newState.set('videoVolume', action.volume)

            // return newState
            return state.set('videoVolume', action.volume)
        case VideoPlayerActions.MUTE_VIDEO_VOLUME:
            return state.set('isVideoVolumeMuted', true)
        case VideoPlayerActions.UNMUTE_VIDEO_VOLUME:
            return state.set('isVideoVolumeMuted', false)
        case VideoPlayerActions.TOGGLE_VIDEO_VOLUME_MUTED:
            const wasVideoVolumeMuted = state.get('isVideoVolumeMuted'),
                previousVolume = state.get('videoVolume')

            if (wasVideoVolumeMuted && previousVolume == 0) {
                // (smart default) on the condition that
                // we have volume at zero & it was muted,
                // untoggling also means adjust volume to 100%

                let newState = state
                newState = newState.set('isVideoVolumeMuted', false)
                newState = newState.set('videoVolume', 100)
                return newState
            } else {
                // or just untoggle
                return state.set('isVideoVolumeMuted', !wasVideoVolumeMuted)
            }

        case VideoPlayerActions.SET_START_TIME:
            return state.set('videoStartTime', action.second)

        case VideoPlayerActions.PLAY_VIDEO:
            return state.set('videoPlayState', VideoPlayStates.PLAYING)
        case VideoPlayerActions.PAUSE_VIDEO:
            return state.set('videoPlayState', VideoPlayStates.PAUSED)
        case VideoPlayerActions.STOP_VIDEO:
            return state.set('videoPlayState', VideoPlayStates.STOPPED)
        case VideoPlayerActions.SET_DRAG_HINT_DETAILS: {
            return state.mergeIn(['draggingHint'], action.draggingHint)
        }
        default:
            return state
    }
}
